import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/brand/brand/apps/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import { Label } from '@primer/react';
import { PropTableValues } from '../../src/components';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import {RiverAccordion} from '@primer/react-brand'
`}</code></pre>
    <h2>{`Examples`}</h2>
    <h3>{`Default`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<RiverAccordion>
  <RiverAccordion.Item>
    <RiverAccordion.Heading>Heading 1</RiverAccordion.Heading>
    <RiverAccordion.Content>
      <Text>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. In sapien sit
        ullamcorper id. Aliquam luctus sed turpis felis nam pulvinar risus
        elementum.
      </Text>
      <Link href="#">Call to action</Link>
    </RiverAccordion.Content>
    <RiverAccordion.Visual>
      <img
        src="/brand/assets/placeholder-1.png"
        alt="Visual content for item 1"
      />
    </RiverAccordion.Visual>
  </RiverAccordion.Item>

  <RiverAccordion.Item>
    <RiverAccordion.Heading>Heading 2</RiverAccordion.Heading>
    <RiverAccordion.Content>
      <Text>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. In sapien sit
        ullamcorper id. Aliquam luctus sed turpis felis nam pulvinar risus
        elementum.
      </Text>
      <Link href="#">Call to action</Link>
    </RiverAccordion.Content>
    <RiverAccordion.Visual>
      <img
        src="/brand/assets/placeholder-2.png"
        alt="Visual content for item 2"
      />
    </RiverAccordion.Visual>
  </RiverAccordion.Item>

  <RiverAccordion.Item>
    <RiverAccordion.Heading>Heading 3</RiverAccordion.Heading>
    <RiverAccordion.Content>
      <Text>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. In sapien sit
        ullamcorper id. Aliquam luctus sed turpis felis nam pulvinar risus
        elementum.
      </Text>
      <Link href="#">Call to action</Link>
    </RiverAccordion.Content>
    <RiverAccordion.Visual>
      <img
        src="/brand/assets/placeholder-3.png"
        alt="Visual content for item 3"
      />
    </RiverAccordion.Visual>
  </RiverAccordion.Item>
</RiverAccordion>
`}</code></pre>
    <h3>{`Visual alignment`}</h3>
    <p>{`Use the `}<inlineCode parentName="p">{`align`}</inlineCode>{` prop to control the position of the visuals. Setting `}<inlineCode parentName="p">{`align="end"`}</inlineCode>{` will invert the default position of the visuals and content.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<RiverAccordion align="end">
  <RiverAccordion.Item>
    <RiverAccordion.Heading>Heading 1</RiverAccordion.Heading>
    <RiverAccordion.Content>
      <Text>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. In sapien sit
        ullamcorper id. Aliquam luctus sed turpis felis nam pulvinar risus
        elementum.
      </Text>
      <Link href="#">Call to action</Link>
    </RiverAccordion.Content>
    <RiverAccordion.Visual>
      <img
        src="/brand/assets/placeholder-1.png"
        alt="Visual content for item 1"
      />
    </RiverAccordion.Visual>
  </RiverAccordion.Item>

  <RiverAccordion.Item>
    <RiverAccordion.Heading>Heading 2</RiverAccordion.Heading>
    <RiverAccordion.Content>
      <Text>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. In sapien sit
        ullamcorper id. Aliquam luctus sed turpis felis nam pulvinar risus
        elementum.
      </Text>
      <Link href="#">Call to action</Link>
    </RiverAccordion.Content>
    <RiverAccordion.Visual>
      <img
        src="/brand/assets/placeholder-2.png"
        alt="Visual content for item 2"
      />
    </RiverAccordion.Visual>
  </RiverAccordion.Item>

  <RiverAccordion.Item>
    <RiverAccordion.Heading>Heading 3</RiverAccordion.Heading>
    <RiverAccordion.Content>
      <Text>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. In sapien sit
        ullamcorper id. Aliquam luctus sed turpis felis nam pulvinar risus
        elementum.
      </Text>
      <Link href="#">Call to action</Link>
    </RiverAccordion.Content>
    <RiverAccordion.Visual>
      <img
        src="/brand/assets/placeholder-3.png"
        alt="Visual content for item 3"
      />
    </RiverAccordion.Visual>
  </RiverAccordion.Item>
</RiverAccordion>
`}</code></pre>
    <h2>{`Component props`}</h2>
    <h3>{`RiverAccordion `}<Label mdxType="Label">{`Required`}</Label></h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`children`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><PropTableValues values={[<a href="#riveraccordionitem-required">RiverAccordion.Item[]</a>]} addLineBreaks mdxType="PropTableValues" /></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Multiple RiverAccordion.Item components`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`align`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><PropTableValues values={['start', 'end']} addLineBreaks mdxType="PropTableValues" /></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`'start'`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Controls the position of the visuals relative to the accordion content`}</td>
        </tr>
      </tbody>
    </table>
    <p><inlineCode parentName="p">{`RiverAccordion`}</inlineCode>{` extends the HTML `}<inlineCode parentName="p">{`div`}</inlineCode>{` element and supports all `}<inlineCode parentName="p">{`div`}</inlineCode>{` props.`}</p>
    <h3>{`RiverAccordion.Item `}<Label mdxType="Label">{`Required`}</Label></h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`children`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><PropTableValues values={[<a href="#riveraccordionheading-required">RiverAccordion.Heading</a>, <a href="#riveraccordioncontent-required">RiverAccordion.Content</a>, <a href="#riveraccordionvisual-required">RiverAccordion.Visual</a>]} addLineBreaks mdxType="PropTableValues" /></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Must include all three listed components`}</td>
        </tr>
      </tbody>
    </table>
    <p><inlineCode parentName="p">{`RiverAccordion.Item`}</inlineCode>{` extends the HTML `}<inlineCode parentName="p">{`div`}</inlineCode>{` element and supports all `}<inlineCode parentName="p">{`div`}</inlineCode>{` props.`}</p>
    <h3>{`RiverAccordion.Heading `}<Label mdxType="Label">{`Required`}</Label></h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`children`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Heading text`}</td>
        </tr>
      </tbody>
    </table>
    <p><inlineCode parentName="p">{`RiverAccordion.Heading`}</inlineCode>{` extends the `}<a parentName="p" {...{
        "href": "/brand/components/Heading"
      }}><inlineCode parentName="a">{`Heading`}</inlineCode></a>{` component and supports all `}<inlineCode parentName="p">{`Heading`}</inlineCode>{` props.`}</p>
    <h3>{`RiverAccordion.Content `}<Label mdxType="Label">{`Required`}</Label></h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`children`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`React.ReactElement[]`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Content components`}</td>
        </tr>
      </tbody>
    </table>
    <p><inlineCode parentName="p">{`RiverAccordion.Content`}</inlineCode>{` extends the HTML `}<inlineCode parentName="p">{`div`}</inlineCode>{` element and supports all `}<inlineCode parentName="p">{`div`}</inlineCode>{` props.`}</p>
    <h3>{`RiverAccordion.Visual `}<Label mdxType="Label">{`Required`}</Label></h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`children`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`React.ReactElement`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Visual content (e.g., image)`}</td>
        </tr>
      </tbody>
    </table>
    <p><inlineCode parentName="p">{`RiverAccordion.Visual`}</inlineCode>{` extends the HTML `}<inlineCode parentName="p">{`div`}</inlineCode>{` element and supports all `}<inlineCode parentName="p">{`div`}</inlineCode>{` props.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      